import JSON_HEADERS from 'jsonHeaders'
import camelize from 'lib/camelize'
import readDraft from './readDraft'

export default async function readNewDraft() {
  return fetch('/burosfera/hire/vacancy/new.json', {
    method: 'GET',
    headers: JSON_HEADERS,
    credentials: 'include',
  }).then(res => res.json())
    .then(json => readDraft(camelize(json)))
}
